import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import * as ticketingStates from 'store/updateTicketing';
import formatDateTime from 'utils/formatDateTime';
import { track } from 'utils/tracking';
import { getCopy } from 'utils/copy';
import { joinClasses } from 'utils/utils';
import s from 'components/shared/theaters/ticketing/ticketDetails/ticketDetails.sss';


const EditIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
		<path d="M17.7,3.6l-3.3-3.3c-0.2-0.3-0.5-0.2-0.8,0L2.3,12.5c-0.2,0.2-0.4,0.6-0.4,0.9l-0.8,4c0,0.2,0.1,0.4,0.3,0.4
			h0.1l4-0.8c0.3-0.1,0.6-0.3,0.8-0.5L17.7,4.3C17.9,4.1,17.9,3.8,17.7,3.6z M5.6,15.8c0,0.1-0.2,0.2-0.3,0.2l-3,0.6l0.6-3
			c0-0.1,0.1-0.3,0.2-0.4L12,3.6l2.6,2.6L5.6,15.8z M15.2,5.4l-2.6-2.6L14,1.3l2.6,2.6L15.2,5.4z" />
	</svg>
);


export default class TicketDetails extends Component {

	goToTickets = () => {
		// Go back to ticket selection page
		track({ a: 'ticketing-edit-types' });
		Store.emit(actions.GO_TICKETING_TYPES);
	}

	goToSeating = () => {
		// Go back to seating page
		track({ a: 'ticketing-edit-seating' });
		Store.emit(actions.GO_TICKETING_SEATING);
	}

	render(props) {
		const {
			screening,          // Screening - the currently active screening
			ticketing,          // Object - the ticketing state
			open,               // boolean -
			toggleTicketDetails, // Function -
			currencyCopy = 'CURRENCY'
		} = props;

		const step = ticketing.state;
		// Whats the index of the current step in the flow
		const currentStepIndex = ticketingStates.ticketingOrder.indexOf(step);

		// Whether the order can still be modified
		const canEditOrder = step !== ticketingStates.COMPLETE;
		const canEditTypes = canEditOrder;
		const canEditSeats = canEditOrder && ticketing.seatingSupported;

		const numTickets = [];
		if (ticketing.tickets) {
			// Combine all the quantities into one array
			Object.keys(ticketing.tickets).forEach((ticketType) => {
				numTickets.push(ticketing.tickets[ticketType].quantity);
			});
		}
		// Calculate the total amount of tickets
		const ticketTotal = numTickets.reduce((a, b) => a + b, 0);

		// Details about the different selected tickets
		const ticketTypes = (
			<div
				class={joinClasses(s.selectedTickets, canEditTypes && s.editable)}
				onClick={canEditTypes && this.goToTickets}
			>
				{`${ticketTotal} ${getCopy('TICKETS_SELECTED')}`}
				{canEditTypes && <EditIcon class={s.editIcon} />}
			</div>
		);

		// Details about the selected seats
		let ticketSeating = null;
		if (ticketing.seatingSupported) {
			ticketSeating = (
				<div
					class={joinClasses(s.seatsContainer, canEditSeats && s.editable)}
					onClick={canEditSeats && this.goToSeating}
				>
					{ticketing.seats && ticketing.seats.map(({ label }) => {
						return <div class={s.seat}>{label}</div>;
					})}
					{canEditSeats && <EditIcon class={s.editIcon} />}
				</div>
			);
		}

		// Tickets about the prices
		let ticketPricing = '';
		if (currentStepIndex > 2) {
			// Get price of booking fee
			let bookingFeePrice = '-';
			if (ticketing.order && typeof ticketing.order.bookingFee === 'number') {
				bookingFeePrice = ticketing.order.bookingFee.toFixed(2);
			}

			// Only show after seats are selected
			ticketPricing = (
				<div class={s.ticketPricing}>
					{ticketing.tickets &&
						Object.keys(ticketing.tickets).map((ticketKey) => {
							const ticket = ticketing.tickets[ticketKey];
							let price = '-';
							if (typeof ticket.quantity === 'number' && typeof ticket.price === 'number') {
								price = (ticket.quantity * ticket.price).toFixed(2);
							}

							return (
								<div class={s.priceLine}>
									<span>{ticket.quantity} {ticket.description}</span>
									<span>{getCopy(currencyCopy,{ value: price })}</span>
								</div>
							);
						})}
					<div class={s.priceLine}>
						<span>{getCopy('BOOKING_FEE', {}, 'Booking Fee')}</span>
						<span>{getCopy(currencyCopy, { value: bookingFeePrice })}</span>
					</div>
				</div>
			);
		}

		return (
			<div class={joinClasses(this.props.class, s.header)}>
				<button type='button' class={joinClasses(s.arrow, open ? s.arrowUp : s.arrowDown)} onClick={toggleTicketDetails}>
					<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'>
						<path d='M67.243 25.414l-5.656-5.656-28.83 28.828 28.83 28.828 5.656-5.656L44.07 48.586l23.173-23.172z' />
					</svg>
				</button>
				{open ?
					<div>
						<h3 class={s.title}>
							{getCopy('TITLE')}
							<span class={s.format}>({(screening.movie.format && screening.movie.format.label) || '2D'})</span>
						</h3>
						<p class={s.date}>
							{formatDateTime(screening.nextDayDatetime || screening.datetime, 'dddd o MMMM - ' + getCopy('TIME_FORMAT') + ' ' + getCopy('TIME_PERIOD'), getCopy('DATETIME_LOCALE'))}
						</p>
						{currentStepIndex > 1 && ticketTypes}
						{currentStepIndex > 2 && ticketSeating}
						{ticketPricing}
					</div> :
					<div class={s.bookingDetails} onClick={toggleTicketDetails}>{getCopy('BOOKING_DETAILS')}</div>
				}
				<div class={s.ribbon} />
			</div>
		);
	}

}
